'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from 'react';
const className = (disabled) => disabled
    ? 'accent-input-border-color opacity-45'
    : 'accent-input-border-color';
const Checkbox = (_a) => {
    var { disabled = false, onChange, checked } = _a, props = __rest(_a, ["disabled", "onChange", "checked"]);
    const id = useId();
    return (_jsx("input", Object.assign({ disabled: disabled, id: id, className: className(disabled), checked: checked, type: "checkbox", onChange: (e) => onChange === null || onChange === void 0 ? void 0 : onChange(e.currentTarget.checked) }, props)));
};
export default Checkbox;
//# sourceMappingURL=index.js.map